<template>
  <div id="contenedor-principal-reportedefirmasnovigentes" style="position:relative;">
    <div id="contenedor-encabezados-reportedefirmasnovigentes" class="text-left">
      <h1>Reporte de firmas no vigentes</h1>
      
    </div>
    <div id="contenedor-principal-reportedefirmasnovigentes" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      
      <div id="contenedor-filtros-reportedefirmasnovigentes" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      
       <div v-bind:class="['area']">

       <!-- <div v-show="!mostrarFormularioEdicionFirma"  id="contenedor-filtros-reportedefirmasnovigentes" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'wrapDivBloqueado': '']">
       <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'area bloquearDiv': 'area']">    -->   
        
        <div >
       
            <FiltroReportesFirmasNoVigentes 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :key="'filtro'+contrenderfiltrosreportes"
                :AccionesMostrar="comportamientoFiltroDeBusquedaFirmas"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarProcesadoAPI"
                :ejecutaLaFuncion2="buscarProcesadoAPI2"
                :ejecutaLaFuncion3="buscarProcesadoAPI3"
                :ejecutaLaFuncion4="buscarProcesadoAPI4"
                :area="obtenerAreaDeUsuario"
                :tituloDeBusqueda="'Búsqueda de firmas no vigentes'"
                v-on:emitGetTipoReporte="tituloSeleccionadodelFiltro = $event"              
                :ref="'filtroBusqueda'">
            </FiltroReportesFirmasNoVigentes>

            
      
          </div>
        </div>
      
                     
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0" id="ProcesadosEncontrados_div">
        <div class="area">
          <transition name="fade">

          <!-- <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0)" style="background-color:black; padding: 8px;"> -->

          <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0)" style="background-color:black; padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-file mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Reporte de Firmas No Vigentes a encontrar</h5>
                <!-- Esto es lo que se muestra antes de la busqueda -->
              </div>
            </div>
          </div>
          <TablaDeResultadosFirmas 
            v-else-if="firmas != undefined && firmas != null"
            
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaReporteFirmasNoVigentes="firmas"
            :TablaReporteFirmasNoVigentesFecha="firmasfecha"
            :TablaReporteFirmasNoVigentesFechaActual="firmasfechaactual"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            :tituloTablaReporteFirmasNoVigentes="tituloTablaString"
            >

          </TablaDeResultadosFirmas>
          </transition>
   

        </div>


        


      </div> 




    </div>
    
  </div>
</template>

<script>
import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
import FiltroReportesFirmasNoVigentes from '@/components/SIVAC/Comun/FiltroReportesFirmasNoVigentes'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'




export default {
    components: {
      FiltroReportesFirmasNoVigentes,
      TablaDeResultadosFirmas
    },
    
    data(){
      return{
          enumeraciones,
          tituloDeRecibodeFirma:'',
          
          accionesdelaTablaDeResultadosFirmas:{
          alta: true,
          impresion: true,
          cambios: true,
          visualizacion: true,
          altamanual: true,
          bajapersona: true,
          mensaje: true,
          output: null,
          reportes: true,
          consulta: false,
        },

        comportamientoFiltroDeBusquedaFirmas:{            
          administracion: true,
          consulta: false
        },

        catalogos: [          
          
          { catalogoId: enumeraciones.catalogos.EstatusFirma, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_EstatusFirma' },
          { catalogoId: enumeraciones.catalogos.FechaDeInicio, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_FechaInicial' },
          { catalogoId: enumeraciones.catalogos.FechaFinal, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_FechaFinal' },

          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' }
        ],
        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },
        firmas: null,
        firmasfecha:null,
        firmasfechaactual:null,
        Firma: null,
        FechaInicial: null,
        FechaFinal: null,
        tituloTablaString: '',
        tituloSeleccionadodelFiltro: '',

        elementosAConservar: {


          tiposDocumento: [1,5],
           areas: [12,95],
           partidosJudiciales: [1],
           materias: [6],
           entidades: [1],


        },

        contrenderfiltrosreportes: 0,


         actualizoarea: false,
      }
    },


    computed:{

      // elementosAConservar : function()
      // {
      //   let ep = {  
          
      //      tiposDocumento: [1,5],
      //      areas: [12,95],
      //      partidosJudiciales: [1],
      //      materias: [6],
      //      entidades: [1],
           
      //   }

      //    console.log(ep);


      //   return ep;

      // },


      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {
        
          
        return this.$store.getters.Get_AreaDelUsuario;


      }




    },


    watch: {
        '$store.getters.Get_AreaDelUsuario': function() {
            
            //console.log("entro en watch", this.$store.getters.Get_AreaDelUsuario);


            if(!this.actualizoarea){

              if((this.$store.getters.Get_AreaDelUsuario==null || this.$store.getters.Get_AreaDelUsuario==undefined) || (this.$store.getters.Get_AreaDelUsuario.AreaId==112) ||  (this.$store.getters.Get_AreaDelUsuario.AreaId==1)){


                
                
                this.actualizoarea= true; 

              }

              this.contrenderfiltrosreportes++;




            }
        }
    },






    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI:function() 
      {
        this.firmasfechaactual= null; 
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,
          FechaInicial: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaInicial) ? this.$refs['filtroBusqueda'].fechaInicial : null,
          FechaFinal: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaFinal) ? this.$refs['filtroBusqueda'].fechaFinal : null,

          TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null,



          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null,
          TipoFiltroEjecucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroEjecucionId) ? this.$refs['filtroBusqueda'].TipoFiltroEjecucionId : null,
          TipoFiltroSegundoPenalId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId) ? this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId : null
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.firmas.BuscarFirmasNoVigentesPorPeriodoDeFecha, parametros, headerPeticion)
          .then(respuesta => { 
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteFirmasNoVigentesPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },


          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI2:function() 
      { 
        // this.firmasfecha= null;
        this.firmasfechaactual= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,

          TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null,




          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null,
          TipoFiltroEjecucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroEjecucionId) ? this.$refs['filtroBusqueda'].TipoFiltroEjecucionId : null,
          TipoFiltroSegundoPenalId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId) ? this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId : null
          
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.firmas.BuscarFirmasNoVigentesSemanaActual, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteFirmasNoVigentesPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },



          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI3:function() 
      { 
        // this.firmasfecha= null;
        this.firmasfechaactual= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,

          TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null,




          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null,
          TipoFiltroEjecucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroEjecucionId) ? this.$refs['filtroBusqueda'].TipoFiltroEjecucionId : null,
          TipoFiltroSegundoPenalId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId) ? this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId : null
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.firmas.BuscarFirmasNoVigentesSemanaAnterior, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteFirmasNoVigentesPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },



          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI4:function() 
      { 
        this.firmasfecha= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,

          TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null,




          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null,
          TipoFiltroEjecucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroEjecucionId) ? this.$refs['filtroBusqueda'].TipoFiltroEjecucionId : null,
          TipoFiltroSegundoPenalId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId) ? this.$refs['filtroBusqueda'].TipoFiltroSegundoPenalId : null
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.firmas.BuscarFirmasNoVigentesPorHistorial, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfechaactual= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteFirmasNoVigentesPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },


      validarDatosBusquedaProcesado: function(datos)
      {
        if( 

            (datos.TipoEstatusFirmaId == null || datos.TipoEstatusFirmaId == -1) &&
            (datos.ClaveDelProcesado == null || datos.ClaveDelProcesado == undefined) &&
            (datos.Nombre == null || datos.Nombre == undefined) && 
            (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined) && 
            (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined)
             
        )
        {          
            comun.mensajeDeAlerta("Favor de llenar por lo menos un campo del formulario.", null, null);
            return false;
        }
        return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },



      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {



      },














      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        
        
        this.limpiarValores();
        // this.limpiarTablaResultados(); // para quitar la tabla de resultados
        // this.buscarProcesadoAPI();

      },



     // firmas no vigentes = firmas realizadas











     }
    }

</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/ReporteFirmasNoVigentes.vue